module.exports = "<h3 translate=\"404_not_found\"></h3>\n<h4 translate=\"not_found_text\">\n</h4>";


//////////////////
// WEBPACK FOOTER
// ./src/app.common/modules/templates/notFound.html
// module id = 16
// module chunks = 0 1 2 3 4